<template>
  <div class="node" :style="{ marginLeft: depth * 20 + 'px' }">
    <div class="container">
      <!-- code here -->
      <div class="menu-item">
        <span class="menu-button menu-button--black">
          <span class="type" v-if="hasChildren" @click="expanded = !expanded">{{
            expanded ? "&#9660;" : "&#9658;"
          }}</span
          >{{ node.name }}</span
        >
      </div>
    </div>

    <TreeItem
      v-if="expanded"
      v-for="child in node.children"
      :key="child.name"
      :node="child"
      :depth="depth + 1"
    />
  </div>
</template>
<script>
export default {
  name: "TreeItem",
  props: {
    node: Object,
    depth: {
      type: Number,
      default: 0,
    },
    emits: ["add-state"],
  },
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
    },
  },
  computed: {
    hasChildren() {
      return this.node.children.length;
    },
    type() {
      return this.node.type;
    },
    id() {
      return this.node.id;
    },
  },
};
</script>
<style scoped>
.type {
  cursor: pointer;
}
</style>